import {
  AVATAR_COLORS,
  PANEL_MEMBER_ROLE_LABEL
} from './panel_register_constants';

export function build_metrics(members = []) {
  const total = members.length;
  const active = members.filter((member) => member.is_active !== false).length;
  const warning = members.filter((member) => member.availability_key === 'at-capacity').length;

  return [
    metric('Total Panel', String(total), `${active} active`, 'text-purple', 'bi-people'),
    metric('Active', String(active), active_ratio(active, total), 'secondary-color', 'bi-person-check'),
    metric('Capacity Warning', String(warning), 'Review required', 'text-purple', 'bi-exclamation-triangle'),
    metric('Avg SLA', average_sla(members), 'Target 90%', 'secondary-color', 'bi-clock-history')
  ];
}

export function build_regional_scopes(members = [], groups = []) {
  const grouped = group_by_scope(members);
  groups.filter((group) => !grouped.has(group.name)).forEach((group) => {
    grouped.set(group.name, []);
  });

  return Array.from(grouped.entries()).map(regional_scope_item);
}

function regional_scope_item([scope_name, scope_members]) {
  return {
    name: scope_name,
    meta: 'Role group',
    members: String(scope_members.length),
    sla_ok: average_sla(scope_members),
    composition: role_composition(scope_members)
  };
}

export function build_role_mix(members = []) {
  const grouped = members.reduce((result, member) => {
    const role_name = member.role || PANEL_MEMBER_ROLE_LABEL;
    result.set(role_name, (result.get(role_name) || 0) + 1);
    return result;
  }, new Map());
  return Array.from(grouped.entries()).map(role_mix_item);
}

function role_mix_item([role_name, count], index) {
  return {
    name: role_name,
    count: String(count),
    dot_style: `background-color: ${AVATAR_COLORS[index % AVATAR_COLORS.length]}`
  };
}

function metric(label, value, change, change_class, icon) {
  return { label, value, change, change_class, icon };
}

function active_ratio(active, total) {
  return total ? `${Math.round((active / total) * 100)}% utilisation` : '0% utilisation';
}

function average_sla(members = []) {
  const values = members
    .map((member) => Number(String(member.sla || '').replace('%', '')))
    .filter(Number.isFinite);

  if (!values.length) {
    return 'No SLA data';
  }

  const average = values.reduce((sum, value) => sum + value, 0) / values.length;
  return `${Math.round(average)}%`;
}

function group_by_scope(members = []) {
  return members.reduce((result, member) => {
    const scope = member.scope || 'Unassigned scope';
    const scope_members = result.get(scope) || [];
    scope_members.push(member);
    result.set(scope, scope_members);
    return result;
  }, new Map());
}

function role_composition(members = []) {
  const role_names = [...new Set(members.map((member) => member.role || PANEL_MEMBER_ROLE_LABEL))];
  return role_names.map(role_badge);
}

function role_badge(label) {
  return {
    label,
    badge_class: 'bg-primary-subtle text-primary-emphasis border border-primary-subtle'
  };
}
